import instance from '../../axios';

export const getVoucherList = async (from, to, id) => {
    const response = await instance.get('voucher?from=' + from + '&to=' + to + `${id ? `&boothId=${id}` : ``}`)
    return response.data
}

export const getVoucherSummary = async (from, to, id) => {
    const response = await instance.get('voucher/vouchers-summary?dateFrom=' + from + '&dateTo=' + to + `${id ? `&boothId=${id}` : ``}`)
    return response.data
}

export const getVoucherDetail = async (id, vid) => {
    const response = await instance.get('voucher/getDetail?id=' + vid + `${id ? `&boothId=${id}` : ``}`)
    return response.data
}